// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VgPp","left":"styles_left__3jC3d","right":"styles_right__2IDPt","alert":"styles_alert__xgGxd"};